import axiosInstance from "../instance/AxiosInstance";

export const getAnnouncements = (params) => {
  return axiosInstance.get("announcements/list", {
    params: {
      pageNo: params.pageNo || 1,
      pagesize: params.pagesize || 10,
      pagination_required: true,
      search: params.search || undefined,
    },
  });
};

export const createAnnouncement = (data) => {
  return axiosInstance.post("announcements/create", data);
};

export const generateAnnouncementAI = async (params) => {
  const { subject, theme, role, org_name, tone = "neutral", length = "medium" } = params;

  if (!theme && !subject) {
    throw new Error("Theme or Subject is required");
  }

  const prompt = `Task: Create a professional and thorough announcement based on the details provided.
    Theme: "${theme || ""}"
    Subject: "${subject || ""}"
    Sender Name: "${org_name || "[Your Name]"}"
    Sender Position: "${role || "[Your Position]"}"
    Tone: ${tone}
    Length: ${length === "short" ? "at least 2 thorough paragraphs" : length === "medium" ? "3 paragraphs" : "4-5 detailed paragraphs"}

    Context: Focus the announcement content on the "Theme" if provided. If "Subject" is also provided, incorporate it.
    The response MUST include a signature using the provided "Sender Name" and "Sender Position".

    You MUST respond with a valid JSON object only. Do not include any other text.
    The JSON structure MUST be:
    {
      "theme": "A 1-2 word category like 'Meeting', 'Holiday', 'Policy', 'Alert'",
      "content": "The full announcement message content"
    }

    The "content" field MUST end with EXACTLY this closing:
    Best regards,
    ${role || "[Your Position]"}
    ${org_name || "[Your Name]"}`;

  const body = {
    messages: [
      {
        role: "system",
        content: "You are a professional assistant. Always respond in valid JSON format with 'theme' and 'content' keys.",
      },
      { role: "user", content: prompt },
    ],
  };

  try {
    const resp = await fetch("https://api.a0.dev/ai/llm", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!resp.ok) {
      throw new Error(`AI service error: ${resp.status}`);
    }

    const json = await resp.json();
    let completion = "";

    if (json && typeof json.completion === "string") {
      completion = json.completion.trim();
    }

    if (!completion) {
      throw new Error("Empty response from AI service");
    }

    try {
      const jsonMatch = completion.match(/\{[\s\S]*\}/);
      const jsonStr = jsonMatch ? jsonMatch[0] : completion;
      const parsed = JSON.parse(jsonStr);

      return {
        theme: (parsed.theme || parsed.Theme || "").trim(),
        content: (parsed.content || parsed.Content || jsonStr).trim(),
      };
    } catch (e) {
      return { content: completion };
    }
  } catch (err) {
    console.error("Generate Announcement Error:", err);
    throw new Error(err?.message || "Failed to generate announcement");
  }
};
